import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import get from 'lodash/get';
import set from 'lodash/set';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicDevicetypesPacketParserWrapper',
  mixins: [formMixin, parserTypesMixin],
  props: {
    deviceTypeId: {
      type: String,
      required: false,
      default: null
    },
    deviceTypeData: {
      type: Object,
      required: true
    },
    emitInsteadOfSave: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSaveBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    callFromDeviceType: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      originalParserConfig: null,
      formIsDirty: false,
      parserSavePrompt: false,
      parserDuplicateKeysPrompt: false,
      // persist of the `next` function from `beforeRouteLeave`
      unsavePromptNextPersist: null,
      formComponent: null,
      switchParserPrompt: false,
      deviceTypeDataInternal: cloneDeep(this.deviceTypeData)
    };
  },
  computed: _objectSpread(_objectSpread({
    deviceTypeParser: function deviceTypeParser() {
      // in case parser is null, a `, {})` in the get would not work
      return get(this.deviceTypeDataInternal, 'parser') || {};
    }
  }, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    formCardButtons: function formCardButtons() {
      if (get(this.deviceTypeDataInternal, 'parser.type', 'unset') === 'unset') {
        return [];
      }

      var btns = [{
        icon: 'fal fa-repeat-alt',
        color: 'danger',
        title: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserButton'),
        tooltip: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserButton'),
        action: 'switch-parser-type',
        valid: this.isIotHubManager && get(this.deviceTypeDataInternal, 'parser.type', 'unset') !== 'unset'
      }];

      if (this.hideSaveBtn !== true) {
        btns.push({
          icon: 'fas fa-save',
          title: this.$i18n_t('Common.save'),
          tooltip: this.$i18n_t('Common.save'),
          action: 'submit-form',
          valid: this.isIotHubManager ? undefined : false,
          type: 'submit'
        });
      }

      return btns;
    },
    parserTypeName: function parserTypeName() {
      var type = get(this.deviceTypeDataInternal, 'parser.type', 'unset');
      return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes')[type];
    }
  }),
  watch: {
    deviceTypeData: {
      handler: function handler(newVal) {
        this.deviceTypeDataInternal = cloneDeep(newVal);
      },
      deep: true
    },
    deviceTypeDataInternal: function deviceTypeDataInternal() {
      var _this = this;

      if (this.deviceTypeData && !this.deviceTypeData.parser) {
        this.deviceTypeData.parser = {};
      }

      this.$nextTick(function () {
        _this.formComponent = get(_this.$refs, 'formComponent.formElement', null);
      });
    },
    deviceTypeParser: {
      handler: function handler() {
        if (this.originalParserConfig == null) {
          this.formIsDirty = false;
        } else {
          this.formIsDirty = !isEqual(this.originalParserConfig, this.deviceTypeParser);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (this.deviceTypeDataInternal && !this.deviceTypeDataInternal.parser) {
      this.deviceTypeDataInternal.parser = {
        config: {}
      };
    }
  },
  methods: {
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      // If the form is dirty and the user did not confirm leave,
      // prevent losing unsaved changes by canceling navigation
      if (this.formIsDirty) {
        this.unsavePromptNextPersist = next;
        this.parserSavePrompt = true;
      } else {
        next();
      }
    },
    beforeWindowUnload: function beforeWindowUnload(e) {
      if (this.formIsDirty) {
        // Cancel the event
        e.preventDefault(); // Chrome requires returnValue to be set

        e.returnValue = ''; // eslint-disable-next-line no-empty-function

        this.unsavePromptNextPersist = function () {};

        this.parserSavePrompt = true;
      }
    },
    switchParserType: function switchParserType() {
      this.switchParserPrompt = false;
      this.deviceTypeDataInternal.parser = {
        type: 'unset',
        config: {}
      };
      this.emitChanges();
    },
    parserConfigUpdated: function parserConfigUpdated(newConfig) {
      var _this2 = this;

      if (newConfig) {
        set(this.deviceTypeDataInternal, 'parser.config', newConfig);
      }

      this.$nextTick(function () {
        _this2.formComponent = get(_this2.$refs, 'formComponent.formElement', null);
      });

      if (this.emitInsteadOfSave) {
        this.emitChanges();
      } else {
        Object.assign(this.deviceTypeData, this.deviceTypeDataInternal);
      }
    },
    parserUpdated: function parserUpdated(newConfig) {
      if (newConfig) {
        set(this.deviceTypeDataInternal, 'parser', newConfig);
      }

      this.parserConfigUpdated();
    },
    saveParserPreflight: function saveParserPreflight() {
      var calculations = get(this.deviceTypeDataInternal, 'parser.config.calculateElements', []);
      var lowercase_keys = calculations.map(function (entry) {
        return entry.target.toLowerCase();
      });
      var unique_keys = new Set(lowercase_keys);

      if (lowercase_keys.length !== unique_keys.size) {
        this.parserDuplicateKeysPrompt = true;
        return;
      }

      this.saveParser();
    },
    emitChanges: function emitChanges() {
      var clonedData = cloneDeep(this.deviceTypeDataInternal);
      this.$emit('save-parser', clonedData);
    },
    saveParser: function saveParser() {
      var _this3 = this;

      if (this.emitInsteadOfSave) {
        this.emitChanges();
        return;
      }

      NiotaClassicApiService.deviceTypesUpdate(this.deviceTypeId, this.deviceTypeDataInternal, 'parser').then(function () {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.DeviceTypes.snacks.parserSaved'), 'success');

        _this3.originalParserConfig = cloneDeep(_this3.deviceTypeDataInternal.parser);
        _this3.formIsDirty = false;
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.DeviceTypes.snacks.parserSaveFailed'), 'error');
      });
    }
  }
};